import { motion } from "framer-motion";
import React from "react";
import CircularProgressbarElement from "../CircularProgressBar/CircularProgressbarElement";
export default function Skills() {
  // const isAboveMediaScreen = useMediaQuery("(min-width:1060px)");
  let ResponsiveVariants = {};
  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    ResponsiveVariants = {
      hidden: { opacity: 0, x: 50 },
      visible: { opacity: 1, x: 0 },
    };
  }

  return (
    <section id="skills" className="pt-10 pb-24">
      <div className="md:flex md:justify-between md:gap-16 mt-10">
        <motion.div
          className="md:w-1/3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: 50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <p className="font-lato font-semibold text-4xl mb-5">
            My <span className="text-red">Skills</span>
          </p>
        </motion.div>
      </div>
      <motion.div
        className="flex md:flex-row flex-col flex-wrap justify-between items-center md:mt-2 mt-8  "
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        variants={ResponsiveVariants}
      >
        <div className="flex  items-center flex-wrap justify-center md:flex-row sm:flex-row flex-col">
          <CircularProgressbarElement name={"Django"} percentage={90} />
          <CircularProgressbarElement name={"JavaScript"} percentage={95} />
          <CircularProgressbarElement name={"MongoDB"} percentage={80} />
          <CircularProgressbarElement name={"MySQL"} percentage={90} />
          <CircularProgressbarElement name={"Python"} percentage={95} />
          <CircularProgressbarElement name={"React"} percentage={85} />
          <CircularProgressbarElement name={"React Native"} percentage={85} />
          <CircularProgressbarElement name={"Electron js"} percentage={85} />
          <CircularProgressbarElement name={"Flutter"} percentage={50} />
          <CircularProgressbarElement name={"HTML"} percentage={95} />
          <CircularProgressbarElement name={"CSS"} percentage={95} />
          <CircularProgressbarElement name={"MERN"} percentage={88} />
        </div>
      </motion.div>
    </section>
  );
}
